import ContentPage, { Section } from "./ContentPage";
import { DELETE_ACCOUNT } from "../data/legal";

export default function DeleteAccount() {
  return (
    <ContentPage
      title={DELETE_ACCOUNT.title}
      updated={DELETE_ACCOUNT.updated}
      lead={DELETE_ACCOUNT.lead}
    >
      {DELETE_ACCOUNT.sections.map((section) => (
        <Section
          key={section.heading}
          heading={section.heading}
          body={section.body}
          items={section.items}
        />
      ))}
    </ContentPage>
  );
}
